{"mimecast_ui_package_version":"5.13.2","CDN_BASE_URL":"https://d2hlvp5lfy8w3p.cloudfront.net"}